import { i18n } from '@fs/zion-locale'

export default {
  placesWithin: (count) => i18n.t('placesWithin.placesWithin', '{count} Places Within', { count }),
  present: () => i18n.t('placesWithin.present', 'Present'),
  presentYear: () => i18n.t('placesWithin.presentYear', 'Present'),
  showAll: (count) => i18n.t('placesWithin.showAll', 'Show All {count}', { count }),
  showLess: () => i18n.t('placesWithin.showLess', 'Show Less'),
  unknownYear: () => i18n.t('placesWithin.unknownYear', 'Unknown'),
  yearRange: (fromYear, toYear) => i18n.t('placesWithin.yearRange', '{fromYear}–{toYear}', { fromYear, toYear }),
}
